import { gql } from '@apollo/client'

const UPDATE_ORDER_ARTICLE = gql`
  mutation updateOrderArticle($idOrder: UUID!, $idArticle: UUID!, $id: UUID!) {
    updateOrderArticle(
      input: { patch: { idArticle: $idArticle, idOrder: $idOrder }, id: $id }
    ) {
      clientMutationId
    }
  }
`

export default UPDATE_ORDER_ARTICLE
